// extracted by mini-css-extract-plugin
export default {"inputGroup":"multiCheckboxWrapper_inputGroup__RttFp","vertical":"multiCheckboxWrapper_vertical__Hsyl9"};